module.exports = __webpack_public_path__ + "img/4-1.4028d304.jpg";